<template>
    <div class="list">
        <div class="list-wrapper"
            v-if="isLoaded && isHaveItem">
            <FreeGiftHistoryItem
                v-for="(purchase, k) in purchases"
                :key="k"
                :index="k"
                :lbl="lbl"
                :purchase="purchase"
                @clickPurchase="clickPurchase($event)"
                @clickCancelBooking="clickCancelBooking($event)"
            ></FreeGiftHistoryItem>
        </div>
        <SerialFreegiftModal
            :lbl="lbl"
            :busSerialModal="busSerialModal"
            @serialExpired="serialExpired($event)"
            @clickUseNow="clickUseNow($event)">
        </SerialFreegiftModal>
        <modal view="purchase-list"
            :busModal="busModal"></modal>

        <CancelbookingModal
            :lbl="lbl"
            :busModal="busCancelBooking"
            @clickCancelBooking="callApiCancelBooking($event)"></CancelbookingModal>
    </div>
</template>
<script>
import Vue from 'vue';
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/locale.js';
//service
import FreeGiftHistoryItem from './FreeGiftHistoryItem.vue';
import BzbsHistory from '@/service/BzbsHistory.js';
import DiorApi from '@/service/dior/DiorApi.js';
//modal
import Modal from '@/components/modal/Modal.vue';
import SerialFreegiftModal from '../../../Detail/Modal/SerialFreegiftModal.vue';
import CancelbookingModal from './modal/CancelBookingModal.vue';
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from "@/service/config/HistoryConfigModel.js";
/**
 * property
 * @property {object} lbl Text for component.
 * @property {boolean} isLoading Loading status.
 * @property {object} listConfig Configuration for call api.
 * @property {object} filterConfig Filter configuration for call api.
 * @property {object} busEvent Bus event for parent component.
 * event
 * @event clickPurchase Click purchase item.
 * parent component bus event.
 * @event toggleLoading toggle loading in parent component.
 */
export default {
    name: "PurchaseList",
    components: {
        FreeGiftHistoryItem,
        Modal,
        SerialFreegiftModal,
        CancelbookingModal
    },
    props: {
        lbl: Object,
        isLoading: Boolean,
        listConfig: Object,
        filterConfig: Object,
        busEvent: Object,
        tracking: Object
    },
    data: function () {
        return {
            purchases: [],
            isLoaded: false,
            isHaveItem: true,
            isForceRender: true,
            isSerialLoading: false,

            clickedIndex: 0,

            campaignType: Vue.CampaignType,
            busModal: new Vue(),
            busSerialModal: new Vue(),
            busCancelBooking: new Vue(),
            bzbConfig: Vue.bzbsConfig,
            freelistConfig: null,
            freefilterConfig: null,
        };
    },
    created: function () {
        this.freelistConfig = this.listConfig;
        this.freefilterConfig = this.filterConfig;
    },
    mounted: function () {
        //page busEvent.
        this.busEvent.$on('switchLang', this.switchLang);
        this.busEvent.$on('reinitList', this.setConfig);
        //modal busEvent

        this.getList();
        this.initialSeeMore();
    },
    methods: {
        //initial
        initialSeeMore: function () {
            window.onscroll = () => {
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            }
        },
        clickCancelBooking: function (index) {

            var purchase = this.purchases[index];
            this.clickedIndex = index;
            var diorProfile = Account.getCacheDiorProfile();
            var tmpParam = {
                name: diorProfile.memberName,
                membercode: diorProfile.memberCode,
                orderCode: purchase.orderCode,
                brance: purchase.counterName,
                bonusPoint: purchase.bonusPoint,
                imgCampaign: `${this.bzbConfig.bzbsBlobUrl}/config/dior/gift/${purchase.giftCode}.png?type=large`,
                giftName: purchase.giftName,
                reservationDate: purchase.reservationDate,
                firstName: diorProfile.firstName
            }
            purchase.dataInfo = tmpParam;
            purchase.serial = purchase.orderCode;

            this.busCancelBooking.$emit('showConfirmRedeemModal', purchase);



        },
        callApiCancelBooking: function (purchase) {
            var token = Account.getToken();

            this.busModal.$emit("showLoadingModal");
            DiorApi.cancelRedeemGift(token, purchase, purchase.giftStatusType).then(result => {
                console.log(result);
                this.$emit('updatePoint');
                this.busModal.$emit("hideLoadingModal");
                this.showAlertCancelModal(this.lbl.history.head_cancel,
                        this.lbl.history.title_cancel,
                        this.lbl.shipping.close,
                        "gift");
                    this.purchases = [];
                    this.getList();
                    this.isSerialLoading = false;
                    this.purchases[this.clickedIndex].updateAfterRedeem(result);

                    var tmpPurchase = this.purchases[this.clickedIndex];
                    if (this.isShowSerialModal(tmpPurchase))
                        this.busSerialModal.$emit('showSerialModal', purchase);
                    else
                        this.refreshList();
            })
            .catch (error => {

                this.busModal.$emit("hideLoadingModal");
                this.isSerialLoading = false;
                console.log(error);
            })

        },
        showAlertCancelModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showAlertCancelModal', configModal);
        },
        //event
        clickPurchase: function (index) {
            //check internet stuff.
            if (this.isSerialLoading) return;
            this.isSerialLoading = true;

            var purchase = this.purchases[index];
            this.clickedIndex = index;
            let trackCamp = purchase.id + "|" + purchase.name;
            this.tracking.event('Privilege_history', 'click_Campaign_Privilege_history ', trackCamp);

            if (!this.isShowSerialModal(purchase)) return;

            var token = Account.getToken();
            if (purchase.type === this.campaignType.Interface) {
                var locale = Locale.getLocaleCode();
                var header = 'false';
                var theme = Vue.bzbsConfig.appname;
                if (purchase.website &&
                    purchase.website.indexOf('/Landing/starbucks')) {
                        window.location.href = purchase.website +
                            '&token=' + token +
                            '&locale=' + locale +
                            '&RedeemKey=' + purchase.redeemKey +
                            '&header=' + header +
                            '&theme=' + theme +
                            '&return_url=' + encodeURIComponent(window.location.href); // ReturnUrl;
                    }
            }
            purchase.branchName = purchase.info3;
            this.busSerialModal.$emit('showSerialModal', purchase);
            // var diorProfile = Account.getCacheDiorProfile();

            // var tmpParam = {
            //     name: diorProfile.memberName,
            //     membercode: diorProfile.memberCode,
            //     orderCode: purchase.orderCode,
            //     brance: purchase.counterName,
            //     bonusPoint: purchase.bonusPoint,
            //     imgCampaign: `${this.bzbConfig.bzbsBlobUrl}/config/dior/gift/${purchase.giftCode}.png?type=large`,
            //     giftName: purchase.giftName,
            //     reservationDate: purchase.reservationDate
            // }

            // purchase.dataInfo = tmpParam;
            // purchase.serial = purchase.orderCode;
            // this.busSerialModal.$emit('showSerialModal', purchase);

            this.isSerialLoading = false;

            this.tracking.event('Privilege_history', 'click_view_code', trackCamp);
        },
        //method
        getList: function () {
            var token = Account.getToken();
            var diorProfile = Account.getCacheDiorProfile();
            this.showLoading();

            BzbsHistory.apiGetPurchase(token, this.freelistConfig, this.freefilterConfig, diorProfile.memberCode)
                .then(purchases => {
                    this.freelistConfig.intSkip += this.freelistConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (purchases &&
                        purchases.length < this.freelistConfig.defaultTopAmount)
                        this.freelistConfig.isSeeMoreEnable = false;
                    //reinitialize list if no skip.
                    if (this.freelistConfig.intSkip == this.freelistConfig.defaultTopAmount)
                        this.purchases = [];

                    for (var purchase of purchases) {
                        //TODO: Add GA Tracking.
                        this.purchases.push(purchase);
                    }

                    this.isLoaded = true;
                    this.isHaveItem = this.purchases.length > 0
                        ? true
                        : false;

                    this.hideLoading();
                })
                .catch(error => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.hideLoading();
                    console.log(error);
                });
        },
        loadMore: function () {
            if (!this.freelistConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;

            setTimeout(() => {
                this.getList();
            }, 500);
        },
        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') return false;
            if (purchase.expireIn && purchase.expireIn <= 0) return false;

            if (purchase.type === this.campaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === this.campaignType.Free ||
                purchase.type === this.campaignType.Deal ||
                purchase.type === this.campaignType.Buy) {
                if (purchase.delivered)  return false;
            }

            if (purchase.type === this.campaignType.Draw) return false;

            return true;
        },
        //utilities
        hideLoading: function () {
            this.toggleLoading(false);
            this.busModal.$emit('hideLoadingModal', {});
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.toggleLoading(true);
            this.busModal.$emit('showLoadingModal', {});

            return false;
        },
        forceRender: function () {
            this.isForceRender = false;

            this.$nextTick().then( () => {
                this.isForceRender = true;
            });
        },
        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },
        //bus event
        switchLang: function () {
            this.purchases = [];
            this.getList();
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
        serialExpired: function () {
            this.purchases[this.clickedIndex].setPurchaseExpired();
            this.refreshList();
        },
        clickUseNow: function () {
            this.reLoadList();
            // var bzbsToken = Account.getToken();
            // BzbsHistory.apiRedeemUse(bzbsToken, campaign.redeemKey)
            //     .then((res) => {
            //         console.log(res);
            //         this.purchases = [];
            //         this.reLoadList();
            //     }).catch((error) => {

            //         console.log(error);
            //     });
        },
        reLoadList: function () {
            var freegiftHistoryConfig = new PurchaseListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.purchaseListConfig)
                .setTop(5)
                .create();
            this.freelistConfig = freegiftHistoryConfig;

            var filterFreegiftHistoryConfig = new PurchaseFilterConfigBuilder()
                .create();

            this.freefilterConfig = filterFreegiftHistoryConfig;

            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';

.list {
    width: 100%;

    .list-wrapper {
        @extend %display-flex;
        width: 100%;
    }
}
</style>
